<h1 mat-dialog-title class="w-100">Edycja pokoju</h1>
<mat-dialog-content class="mat-typograpphy w-auto">
	<fieldset [disabled]="editable" class="d-flex justify-content-around flex-column w-850px">
		<ng-select
			[disabled]="editable"
			[(ngModel)]="data.roomType.id"
			(ngModelChange)="getCodeName(data.roomType.id)"
			placeholder="Wybierz typ produktu"
			required
		>
			<ng-option [value]="item.id" *ngFor="let item of service.mockData.roomType">
				{{ item.code }} | {{ item.name }}
			</ng-option>
		</ng-select>
		<mat-form-field class="w-100">
			<input matInput type="text" id="roomName" [disabled]="editable" [(ngModel)]="data.roomNumber" required />
			<mat-label>Nazwa pokoju</mat-label>
		</mat-form-field>
		<mat-form-field class="w-100" matTooltip="Dopłata za pokój per dzień">
			<input
				matInput
				type="number"
				[disabled]="editable"
				[ngModel]="data.fee !== undefined ? (data.fee | price) : null"
				(ngModelChange)="data.fee = convertPriceToGrosze($event)"
			/>
			<mat-label> Wprowadź dopłatę w PLN</mat-label>
		</mat-form-field>
		<mat-form-field class="w-100">
			<input matInput type="number" [disabled]="editable" [(ngModel)]="data.level" min="-5" max="25" />
			<mat-label>Piętro</mat-label>
		</mat-form-field>
		<mat-form-field class="w-100">
			<mat-select [(ngModel)]="data.view">
				<mat-option [value]="item.value" *ngFor="let item of viewSet">
					{{ item.name }}
				</mat-option>
			</mat-select>
			<mat-label>Widok</mat-label>
		</mat-form-field>
		<ng-select [(ngModel)]="data.conveniences" [multiple]="true" placeholder="Udogodnienia">
			<ng-option [value]="item.id" *ngFor="let item of service.mockData.convenience">
				{{ item.name }}
			</ng-option>
		</ng-select>
		<div class="form-group mb-3 align-self-center w-100 row">
			<div class="col-sm-6">
				<mat-slide-toggle id="isActive" [checked]="data.isActive" [(ngModel)]="data.isActive"
					>Jest aktywny?</mat-slide-toggle
				>
			</div>
			<div class="col-sm-6">
				<mat-slide-toggle id="noName" [checked]="data.isNoName" [(ngModel)]="data.isNoName"
					>Czy jest noName?</mat-slide-toggle
				>
			</div>
		</div>
		<h6>Opis</h6>
		<ckeditor
			id="text"
			name="text"
			[editor]="editor"
			[config]="editorConfig"
			[disabled]="editable"
			[(ngModel)]="data.description"
			matTooltip="Opis tylko i wyłącznie na wewnętrzne potrzeby, nie jest on publikowany"
		></ckeditor>
		<hr />
		<div *ngFor="let subRoom of data.roomSlaves; let i = index">
			<div class="d-flex justify-content-between align-items-center">
				<h4>Pokój podrzędny - {{ i + 1 }}<small class="ms-2 text-danger">* wymagane</small></h4>
				<i class="fa-solid fa-trash-can px-2" (click)="removeSubRoom(i)"></i>
			</div>
			<div class="row mb-3">
				<div class="col-sm-6">
					<ng-select
						[(ngModel)]="subRoom.roomType.id"
						(ngModelChange)="getRoomType(subRoom)"
						placeholder="Wybierz typ pokoju"
						required
					>
						<ng-option>Wybierz typ pokoju z listy</ng-option>
						<ng-option [value]="item.id" *ngFor="let item of service.mockData.roomType">
							{{ item.code }} | {{ item.name }}
						</ng-option>
					</ng-select>
				</div>
				<div class="col-sm-6">
					<div class="input-group">
						<mat-form-field class="w-100" matTooltip="Dopłata za pokój per dzień "
							><input
								matInput
								type="number"
								placeholder="Wprowadź dopłatę"
								[ngModel]="subRoom.fee !== undefined ? (subRoom.fee | price) : null"
								(ngModelChange)="subRoom.fee = convertPriceToGrosze($event)"
							/>
							<mat-label>Wprowadź dopłatę w PLN</mat-label></mat-form-field
						>
					</div>
				</div>
			</div>
		</div>
		<div class="d-flex justify-content-between">
			<button mat-raised-button color="accent" (click)="addSubRoom()">
				<i class="fa-solid fa-plus"></i>Dodaj pokój podrzędny
			</button>
		</div>
	</fieldset>
</mat-dialog-content>
<mat-dialog-actions align="end"
	><button mat-raised-button color="warn" mat-dialog-close>Anuluj</button>
	<button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial (click)="editRoom()">
		Zatwierdź edycje
	</button></mat-dialog-actions
>
